<template>
    <v-list-item ref="infoWindow" lines="three" class="pl-0">
        <template v-slot:prepend>
            <v-img
                tile
                class="thumb my-0"
                :src="$filters.imageUrl(photoUrl, 250)"
                :alt="location.name"
                :lazy-src="$filters.srcHost('/placeholder.png')"
                :width="isCompactMode ? '50' : '125'"
                @error="onImgError"
                @load="load"
            >
                <template v-slot:placeholder>
                    <v-row v-show="!imgError && photoUrl" class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey-lighten-5" />
                    </v-row>
                </template>
            </v-img>
        </template>
        <div :class="isCompactMode ? 'small-content' : ''">
            <v-list-item-title :title="location.name" class="mb-4">
                <span class="text-wrap">
                    {{ location.name }}
                </span>
            </v-list-item-title>
            <div>
                <v-icon color="primary" size="small" start>mdi-shoe-print</v-icon>
                {{ walkingDistance }}
            </div>
            <div>
                <v-icon color="primary" size="small" start>mdi-clock-outline</v-icon>
                {{ walkingDuration }}
            </div>
            <v-divider class="my-2" />
            <div>
                <v-icon color="primary" size="small" start>mdi-car</v-icon>
                {{ drivingDistance }}
            </div>
            <div>
                <v-icon color="primary" size="small" start>mdi-clock-outline</v-icon>
                {{ drivingDuration }}
            </div>
        </div>
    </v-list-item>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class HotelDirectionMapInfoWindow extends Vue {
        @Prop() location
        @Prop() drivingDirectionData
        @Prop() walkingDirectionData

        imgError = false
        clientWidth = 201

        load() {
            this.setSize()
        }

        setSize() {
            this.clientWidth = this.$refs.infoWindow.$el.clientWidth
        }

        onImgError() {
            this.imgError = true
            return false
        }

        get photoUrl() {
            return this.location.photos?.length ? this.location.photos[0].getUrl() : null
        }

        get walkingDistance() {
            const value = this.walkingDirectionData.legs[0].distance.value
            if (value >= 1000) return `${(value / 1000).toFixed(2)} ${this.$t('km')}`

            return `${value} ${this.$t('m')}`
        }

        get drivingDistance() {
            const value = this.drivingDirectionData.legs[0].distance.value
            if (value >= 1000) return `${(value / 1000).toFixed(2)} ${this.$t('km')}`

            return `${value} ${this.$t('m')}`
        }

        get walkingDuration() {
            const min = Math.ceil(this.walkingDirectionData.legs[0].duration.value / 60)

            return `${min} ${this.$t('minute', min)}`
        }

        get drivingDuration() {
            const min = Math.ceil(this.drivingDirectionData.legs[0].duration.value / 60)

            return `${min} ${this.$t('minute', min)}`
        }

        get isCompactMode() {
            return this.clientWidth < 200
        }
    }

    export default HotelDirectionMapInfoWindow
</script>

<style scoped>
    .small-content {
        font-size: 0.8rem !important;
    }
</style>
